module.exports = __webpack_public_path__ + "static/media/payment-method.f66f5549.svg";